import React, { Component } from 'react';
import { connect } from 'react-redux';
import { pending } from 'redux-saga-thunk';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import { Icon, Popconfirm, notification } from 'antd';
import LineItemBeaconList from '../../../components/atoms/LineItemBeaconList/index';
import { resourceDeleteRequest, resourceListReadRequest } from '../../../store/resource/actions';
import { fromEntities, fromResource } from '../../../store/selectors';
import PopoverManual from '../../../components/atoms/PopoverManual/index';

class LineItemBeaconListContainer extends Component {
  state = {
    filterDropdownVisible: false,
  };

  componentDidMount() {
    this.props.getBeaconList().catch(e =>
      notification.error({
        message: 'Error',
        description: typeof e === 'string' ? e : 'Could not retrieve list of beacons.',
        duration: 0,
      })
    );
  }

  columns = () => [
    {
      title: 'Target Beacons',
      dataIndex: 'description',
      key: 'description',
      render: (text, record) => `${record.beacon_id} - ${text}`,
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
    },
    {
      title: 'Remove All',
      dataIndex: '',
      key: '',
      render: (text, record) => (
        <Popconfirm
          placement="topLeft"
          title={`Are you sure you want to remove this ${record.type}?`}
          onConfirm={() => {
            if (record.type === 'beacon') {
              return this.props.deleteBeacon(record.beacon_id);
            }
          }}
          okText="Yes"
          cancelText="No"
        >
          <a href="#remove">Remove</a>
        </Popconfirm>
      ),
      filterDropdownVisible: this.state.filterDropdownVisible,
      onFilterDropdownVisibleChange: visible => this.setState({ filterDropdownVisible: visible }),
      filterDropdown: (
        <PopoverManual
          title="Are you sure you want to remove all?"
          loading={this.props.loadingDeleteAll}
          onConfirm={() => {
            this.props
              .deleteAll()
              .then(() => {
                this.setState({ filterDropdownVisible: false });
                notification.success({
                  message: 'Success',
                  description: 'All beacons have been removed.',
                  duration: 4,
                });
              })
              .catch(e =>
                notification.error({
                  message: 'Error',
                  description: typeof e === 'string' ? e : 'Could not remove all beacons.',
                  duration: 0,
                })
              );
          }}
          onCancel={() => this.setState({ filterDropdownVisible: false })}
        />
      ),
      filterIcon: <Icon type="delete" style={{ color: '#108ee9' }} />,
    },
  ];

  render() {
    return <LineItemBeaconList columns={this.columns()} {...this.props} />;
  }
}

const mapStateToProps = state => {
  const list = fromEntities
    .getList(state, 'advertiserAdBeacon', fromResource.getList(state, 'advertiserAdBeacon'))
    .map(c => ({ ...c, type: 'beacon' }));

  return {
    loadingDeleteAll: pending(state, 'advertiserAdAppBeaconDelete'),
    list,
  };
};

const mapDispatchToProps = (
  dispatch,
  {
    match: {
      params: { lineItemId },
    },
  }
) => ({
  deleteAll: () =>
    dispatch(resourceDeleteRequest('advertiser-ad/:lineItemId/beacon', { lineItemId })),
  deleteBeacon: beaconId =>
    dispatch(
      resourceDeleteRequest('advertiser-ad/:lineItemId/beacon/:id', { id: beaconId, lineItemId })
    ),
  getBeaconList: () =>
    dispatch(resourceListReadRequest('advertiser-ad/:id/beacon', {}, { id: lineItemId })),
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(LineItemBeaconListContainer);
